import { Box, Text } from '@chakra-ui/react';
import { IOrder } from '../../../../../interfaces';
import Colors from '../../../../../config/colors';
import { ORDER_STATUSES } from '../../../../../config/orders';
import { useTranslation } from 'react-i18next';
import TransactionInfoItem from './transactionInfoItem/transactionInfoItem';
import { PAYMENT_LIST } from '../../../../../config/payments';
import { splitString } from '../../../../../utils/string';

interface Props {
    order: IOrder;
    orderStatus: any;
}

export default function TransactionInfo({ order, orderStatus }: Props) {
    const [t] = useTranslation();

    const paymentSystem = PAYMENT_LIST.find(
        (item) => item.name === order?.transaction?.paymentSystem,
    );

    return (
        <Box color={Colors.darkGrey} fontWeight="300" display="flex" flexDirection="column" gap="2">
            {order.transaction && (
                <TransactionInfoItem
                    label={'UUID'}
                    value={splitString(order.transaction.uuid)}
                    isCopyValue
                />
            )}

            {order.transaction?.network && (
                <TransactionInfoItem label={t('network')} value={order.transaction.network} />
            )}
            {paymentSystem && (
                <TransactionInfoItem label={t('payment-system')} value={paymentSystem.title} />
            )}

            {orderStatus?.id === ORDER_STATUSES.completed.id && order.completedAt && (
                <TransactionInfoItem
                    label={t('completed')}
                    value={new Date(order.completedAt).toLocaleString()}
                />
            )}

            <TransactionInfoItem
                label={t('order-created')}
                value={new Date(order.createdAt).toLocaleString()}
            />
        </Box>
    );
}
